<template>
  <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.75 1.74999C1.75 1.10566 2.27233 0.583328 2.91667 0.583328H11.0833C11.7277 0.583328 12.25 1.10567 12.25 1.74999V5.24999H11.0833V1.74999H2.91667V12.25H5.25V13.4167H2.91667C2.27234 13.4167 1.75 12.8943 1.75 12.25V1.74999ZM12.25 9.04166V12.25C12.25 12.8943 11.7277 13.4167 11.0833 13.4167H8.60417V12.25H11.0833V9.04166H12.25ZM9.33333 4.08333H4.08333V5.24999H9.33333V4.08333ZM12.4871 6.62194L6.7947 13.6537L5.88791 12.9197L11.5803 5.88787L12.4871 6.62194ZM7.58333 6.41666H4.08333V7.58333H7.58333V6.41666Z"
      fill="currentColor"
    />
  </svg>
</template>
<script lang="ts" setup></script>
